const LEVELS = ['debug', 'info', 'warn', 'error', 'fatal'];

const getLevelIndex = (level) => LEVELS.indexOf(level || '');
const shouldLog = (requestedLevel) => {
  const configuredLevel = import.meta.env.VITE_LOGGER_LEVEL;

  if (!configuredLevel) {
    return false;
  }

  return getLevelIndex(requestedLevel) >= getLevelIndex(configuredLevel);
};

const serializeError = (value) => {
  if (value instanceof Error) {
    return {
      name: value.name,
      message: value.message,
      stack: value.stack
    };
  }

  if (value && typeof value === 'object') {
    const serialized = {};

    if (value.message) {
      serialized.message = value.message;
    }
    if (value.status) {
      serialized.status = value.status;
    }
    if (value.statusText) {
      serialized.statusText = value.statusText;
    }
    if (value.code) {
      serialized.code = value.code;
    }
    if (value.response) {
      serialized.response = {
        status: value.response.status,
        statusText: value.response.statusText,
        data: value.response.data
      };
    }
    if (value.data) {
      serialized.data = value.data;
    }
    if (value.config) {
      serialized.config = {
        url: value.config.url,
        method: value.config.method,
        baseURL: value.config.baseURL
      };
    }

    if (Object.keys(serialized).length > 0) {
      return serialized;
    }
  }

  return value;
};

const log = (method, title, value) => {
  if (!shouldLog(method)) {
    return;
  }

  const loggerMethod = method === 'fatal' ? 'error' : method;
  const consoleMethod = console[loggerMethod] || console.log;

  if (value === undefined) {
    consoleMethod(title);
    return;
  }

  consoleMethod(title, serializeError(value));
};

const debug = function (title, value) {
  log('debug', title, value);
};

const warn = function (title, value) {
  log('warn', title, value);
};

const error = function (title, value) {
  log('error', title, value);
};

export default {
  debug,
  warn,
  error
};
